import React, { useEffect } from "react";
import reducer from "./services";
import withReducer from "services/withReducer";
// REDUCERS, STATE
import { useDispatch, useSelector } from "react-redux";
import {
  getJournals,
  setSelectedClass,
  setEdit,
  setTabValue,
} from "./services/journalSlice";
// CUSTOM COMPONENTS
import Badge from "./components/Badge/badge";
import TabSelector from "./components/TabSelector/tabSelector";
import JournalContent from "./components/JournalAttendance/journalAttendance";
import JournalExam from "./components/JournalExam/journal_exam";
import Loader from "components/loader";
// UTIL
// STYLES
import "./journal.scss";
import GoodModal from "./components/GoodModal/GoodModal";
import JournalSummary from "./components/JournalSummary/JournalSummary";

const tabs = [
  { name: "Ирц", color: "#8DCF71" },
  { name: "Шалгалтууд", color: "#8DCF71" },
  { name: "Нийт", activate: 2 || 3, color: "#8DCF71" },
];

function Journal() {
  // const [tabValue, setTabValue] = useState(0);
  const statefulSelector = useSelector(({ JournalApp }) => JournalApp.journal);
  const { loading, tabValue } = statefulSelector;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getJournals());
  }, [dispatch]);

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "ArrowRight") {
        event.preventDefault();
        dispatch(setTabValue(tabValue !== 2 ? tabValue + 1 : 2));
      }
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        dispatch(setTabValue(tabValue !== 0 ? tabValue - 1 : 0));
      }
      if (event.key === "Enter" && tabValue !== 3) {
        dispatch(setEdit(true));
      }
    };
    if (!statefulSelector.edit)
      document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [tabValue, statefulSelector.edit, dispatch]);

  const handleClassChange = (classData) => {
    dispatch(
      setSelectedClass(
        statefulSelector.teacherData.schedule_to_detail[classData]
      )
    );
  };

  return (
    <>
      {loading && <Loader />}
      <div className={"journal-card mt-5 flex rounded bg-white "}>
        <div className="child flex">
          <div className="table-header">
            <span className="title">Журнал</span>
            <div>
              {tabs.map((item, index) => {
                return (
                  <TabSelector
                    key={"journal-tab-" + index}
                    name={item.name}
                    active={
                      index === tabValue || (index === 2 && tabValue === 3)
                    }
                    color={item.color}
                    onClick={() => {
                      dispatch(setTabValue(index));
                    }}
                  />
                );
              })}
            </div>
          </div>
          <div className={"hint " + (tabValue === 0)}>
            <Badge status={3} />
            <span>Байгаа</span>
            <Badge status={4} />
            <span>Тасалсан</span>
            <Badge status={1} />
            <span>Өвчтэй</span>
            <Badge status={2} />
            <span>Чөлөөтэй</span>
          </div>
        </div>
        <div className="class-selector flex">
          <select
            name="class"
            id="class-selector"
            onChange={(item) => {
              handleClassChange(item.currentTarget.value);
            }}
          >
            <option value={-1} key={"options-default"}>
              Анги сонгоогүй байна
            </option>
            {statefulSelector.teacherData.schedule_to_detail.map(
              (row, index) => (
                <option value={index} key={"options-" + index}>
                  {row.lesson.name + "|" + row.course.number + row.course.group}
                </option>
              )
            )}
          </select>
          <div className={"edit " + (tabValue === 2)}>
            <button
              title="Enter дарна уу"
              onClick={() => {
                dispatch(setEdit(true));
              }}
            >
              + Бүртгэх
            </button>
          </div>
        </div>
        <div className="table-data">
          {tabValue === 0 && <JournalContent />}
          {tabValue === 1 && <JournalExam />}
          {(tabValue === 2 || tabValue === 3) && <JournalSummary />}
        </div>
      </div>
      <GoodModal />
    </>
  );
}

export default withReducer("JournalApp", reducer)(Journal);
